import {ITheme} from 'contexts/ThemeContext';
import {Platform} from 'react-native';
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  minSize,
} from 'rn-responsive-styles';

export default (props: ITheme) =>
  CreateResponsiveStyle(
    {
      container: {
        flex: 1,
        width: '100%',
        backgroundColor: props.colors.white,
      },
      raiseHandView: {
        backgroundColor: props.colors.purple(0.13),
        borderRadius: 14,
        height: 50,
        justifyContent: 'center',
        alignItems: 'center',
        marginBottom: 12,
        width: '100%',
      },
      reactionsContainer: {
        backgroundColor: props.colors.purple(0.13),
        borderRadius: 14,
        height: 74,
        width: '100%',
        flexDirection: 'row',
        justifyContent: 'space-evenly',
        alignItems: 'center',
      },
      raiseHandViewText: {
        fontSize: 14,
      },
    },
    {
      [minSize(DEVICE_SIZES.SMALL_DEVICE)]: {
        container: {
          width: 343,
          position: 'absolute',
          height: 124,
          bottom: 57,
          overflow: 'hidden',
          borderRadius: 12,
          ...(Platform.OS === 'web'
            ? {
                boxShadow: `0px 0px 3px ${props.colors.shadowGrey}`,
              }
            : {}),
        },
        raiseHandView: {
          marginBottom: 0,
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0,
        },
        reactionsContainer: {
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
        },
      },
    },
  )();
